import React, { Component } from 'react'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import CircularProgress from 'material-ui/CircularProgress';
import ReactTable from 'react-table'
import matchSorter from 'match-sorter'
import "react-table/react-table.css";
import checkboxHOC from "react-table/lib/hoc/selectTable";
import Chance from "chance";
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MultipleApprovals from './MultipleApprovals'
const CheckboxTable = checkboxHOC(ReactTable);
const chance = new Chance()
class ReportTable extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: []
    }
  }
  render() {
    if (this.props.columns.length) {
      return (
        <MuiThemeProvider muiTheme={getMuiTheme()}>
          <ReactTable
            style={{ textAlign: 'center', margin: this.props.margin || '0px 20px' }}
            data={this.props.data}
            filterable
            defaultFilterMethod={(filter, row) =>
              String(row[filter.id]) === filter.value}
            columns={this.props.columns.map((col) => {
              if (col.key !== 'vendor_actions')
                return {
                  Header: col.Header,
                  id: col.key,
                  accessor: d => d[col.key],
                  filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: [col.key] }),
                  filterAll: true,
                  width: col.width,
                  render: col.render
                }
              else
                return {
                  Header: col.Header,
                  id: col.key,
                  accessor: d => d[col.key],
                  width: 220,
                  filterable: col.filterable,
                }
            })}
            defaultPageSize={10}
            className="-striped -highlight"
            noDataText="No Data Found!"
          />
        </MuiThemeProvider >
      )
    }
    else {
      return (
        <MuiThemeProvider>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CircularProgress size={60} thickness={7} />
          </div>
        </MuiThemeProvider>
      )
    }
  }
}
export default ReportTable



// WEBPACK FOOTER //
// ./src/components/Table.js